// Einstieg fuer all.js. Jede Datei gehoert zu genau einem Template
// (gleicher Name), ausser:
//   swiper.js, lightbox-fatbox.js  Einrichtung der Plugins
//   fn_*.js                         Funktionen ueber mehrere Templates hinweg

// Plugins
require("./swiper.js");
require("./lightbox-fatbox.js");

// Inhaltselemente (RockSolid Custom Elements, rsce_*.html5)
require("./rsce_navBar.js");
require("./rsce_header.js");
require("./rsce_banner.js");
require("./rsce_akkordeon.js");
require("./rsce_bewertungen.js");
require("./rsce_groessenberater.js");
require("./rsce_produktList.js");
require("./rsce_popup.js");
require("./rsce_cookieOpen.js");

// Contao-Elemente
require("./ce_form.js");

// Shop (Isotope-Templates, iso_*.html5 und mod_iso_*.html5)
require("./iso_list_Liste.js");
require("./iso_reader_detail.js");
require("./mod_iso_checkout.js");

// Funktionen ueber mehrere Templates hinweg
require("./fn_merkliste.js");
require("./fn_tracking.js");
require("./fn_alttexte.js");


// Einblenden beim Scrollen (AOS)
const AOS = require("aos");

AOS.init({
    duration: 600,
    easing: 'ease-out-sine',
    startEvent: 'load'
});

document.querySelectorAll("img").forEach(img => {
    img.addEventListener("load", () => {
        AOS.refresh();
    })
})
